import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Link } from 'react-router-dom'
import { Element } from '../../../common/html/element'
import { formatText } from '../../../helpers/value'
import { COMPONENTS } from '../../../routers/constants'
import { selectCompanyInfo } from '../store/slice'
import {
  getScoreRangesCreditRisk,
  getScoreRangesPerformance,
} from '../store/thunk'
import { SCORE_TYPE } from './../constant'
import { SCORE_TYPE_ID } from './constant'
import classes from './index.module.scss'
import { ScoreItem } from './ScoreItem'

export const Premium = ({ detailData }) => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const { organizationId } = useSelector(selectCompanyInfo)

  const scoreType =
    detailData?.scoreType === SCORE_TYPE_ID.CREDIT_RISK
      ? SCORE_TYPE.CREDIT_RISK
      : SCORE_TYPE.PERFORMANCE

  useEffect(() => {
    dispatch(
      scoreType === SCORE_TYPE.CREDIT_RISK
        ? getScoreRangesCreditRisk()
        : getScoreRangesPerformance(),
    )
  }, [locale])

  return (
    <>
      <pre className={classes.preContent}>
        {formatText(detailData?.content)}
      </pre>

      <Element className={classes.score}>
        <Element
          className={classes.item}
          style={{ backgroundColor: '#F3F3F3' }}
        >
          <Translate value="alertDetail.PREVIOUS" className="textUppercase" />
          <ScoreItem scoreType={scoreType} score={detailData?.previous} />
        </Element>
        <Element
          className={classes.item}
          style={{ backgroundColor: '#F3F3F3' }}
        >
          <Translate value="alertDetail.CURRENT" className="textUppercase" />
          <ScoreItem scoreType={scoreType} score={detailData?.curent} />
          <Element style={{ color: '#2C73E8' }}>
            <Link
              to={`${COMPONENTS.companyAnalysis.components.score.components.corporateRiskScore.route}?organizationId=${organizationId}`}
              target="_blank"
            >
              <Translate value="alertDetail.VIEW_MORE" className="fw400" />
            </Link>
          </Element>
        </Element>
      </Element>
    </>
  )
}
